module.exports = __webpack_public_path__ + "static/media/stat-tableros.9d569f55.png";